import request from '@/utils/request'
export function submitConsult(data) {
  return request({
    url: `/coursera/common/user/create/er/enroll`,
    method: 'post',
    data
  })
}
export function graduateEnroll(data) {
  return request({
    url: `/coursera/common/user/create/graduate/enroll`,
    method: 'post',
    data
  })
}
//发送验证码
export function sendMsg(data) {
  return request({
    url: `/coursera/common/user/send/msg`,
    method: 'post',
    data
  })
}

//考研推广
export function graduatePromot(data) {
  return request({
    url: `/coursera/common/user/create/graduate/promot`,
    method: 'post',
    data
  })
}

//精英班
export function enrollPwd(data) {
  return request({
    url: `/coursera/common/user/create/enroll-pwd`,
    method: 'post',
    data
  })
}

//老带新项目
export function pullProjects(data) {
  return request({
    url: `/coursera/common/user/create/pull/projects`,
    method: 'post',
    data
  })
}

//老带新项目提交
export function createNewPull(data) {
  return request({
    url: `/coursera/common/user/create/pull`,
    method: 'post',
    data
  })
}

//双十一拼团报名

export function groupBuy(data) {
  return request({
    url: `/coursera/common/user/create/group/buy`,
    method: 'post',
    data
  })
}
